// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CreateDataRequest {
    static getAttributeTypeMap() {
        return CreateDataRequest.attributeTypeMap;
    }
}
CreateDataRequest.discriminator = undefined;
CreateDataRequest.additionalProperties = false;
CreateDataRequest.attributeTypeMap = [
    {
        "name": "contentType",
        "baseName": "contentType",
        "type": "string"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "systemCode",
        "baseName": "systemCode",
        "type": "string"
    },
    {
        "name": "systemId",
        "baseName": "systemId",
        "type": "string"
    },
    {
        "name": "purposeCode",
        "baseName": "purposeCode",
        "type": "string"
    },
    {
        "name": "purposeId",
        "baseName": "purposeId",
        "type": "string"
    },
];
//# sourceMappingURL=createDataRequest.js.map